import { addModal } from 'weblite-web-modal-viewer'
import { ShareContactDialog } from './share-contact-dialog'

const COMPONENT_ID = 'shareContactList'

export const showShareContactDialog = (
  props: Parameters<typeof ShareContactDialog>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: ShareContactDialog,
  },
}
